import React, {FC, useMemo} from 'react';

import {sendDesktopAnalyticsEvent} from '@optimaxdev/analytics/mobile/lib/sendAnalyticsEvent/index';
import {Input, Modal, zIndex} from '@optimaxdev/design-system';

import {Approve, Copy, Icon} from '@optimaxdev/icons';
import {useSelector} from 'react-redux';

import {CART_BUTTON} from 'constants/analytics/events/cart';

import {useCopyWithTimeout} from 'hooks/useCopyWithTimeout/useCopyWithTimeout';

import {getCartShareId} from '../../store/selectors/quoteInfo/quoteInfo';

import s from './shareCartModal.scss';

export type PropsType = {
    isVisible: boolean;
    closePopup: () => void;
};
/**
 * Modal Share Cart Component
 * @params {PropsType} props - component props
 * @returns {ReactElement} component for cart title
 */
export const ShareCartModal: FC<PropsType> = ({closePopup, isVisible}) => {
    const {copyText, isCopied} = useCopyWithTimeout();
    const shareId = useSelector(getCartShareId);

    const shareCartUrl = useMemo(() => {
        return `${window.location.origin}/checkout/cart?token=${shareId}&utm_source=shareCartD`;
    }, [shareId]);

    const handleCopyClick = () => {
        copyText(shareCartUrl);

        sendDesktopAnalyticsEvent(CART_BUTTON, {
            action: 'Share Popup',
            label: 'Copy - Clicked',
        });
    };

    return (
        <Modal isOpen={isVisible} onRequestClose={closePopup} overlay="dark" zIndex={zIndex.popup}>
            <div className={s.modalContent}>
                <p className={s.modalTitle}>Share Cart</p>
                <p className={s.content}>
                    <span className={s.headsUp}>Heads up</span> - When you share your cart, just
                    keep in mind that it might include sensitive information, like your glasses
                    prescription. Any changes you make to your cart will be reflected in the shared
                    link until you checkout or empty your cart.
                </p>
                <div className={s.field}>
                    <div className={s.input}>
                        <Input color="dark" label="" type="text" value={shareCartUrl} />
                    </div>
                    <button className={s.copy} onClick={handleCopyClick} type="button">
                        {isCopied ? (
                            <span className={s.checkIcon}>
                                <Icon height={13} icon={Approve} strokeWidth={2} width={13} />
                            </span>
                        ) : (
                            <span className={s.copyIcon}>
                                <Icon
                                    className={s.icon}
                                    height={13}
                                    icon={Copy}
                                    strokeWidth={2}
                                    width={13}
                                />
                            </span>
                        )}
                        {isCopied ? 'Copied' : 'Copy'}
                    </button>
                </div>
                <p className={s.disclamer}>
                    * We recommend only sharing the link with people you completely trust.
                </p>
            </div>
        </Modal>
    );
};
